import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import store from '@/store';
import { MENU_VISIBLE } from '@/store/actions/configurations';
var Menu = /*#__PURE__*/function (_Vue) {
  function Menu() {
    _classCallCheck(this, Menu);
    return _callSuper(this, Menu, arguments);
  }
  _inherits(Menu, _Vue);
  return _createClass(Menu, [{
    key: "isCopySpeachEnabled",
    get: function get() {
      return store.getters.isCopySpeachEnabled;
    }
  }, {
    key: "isAuthItem",
    get: function get() {
      return store.getters.isAuthItemAvailable;
    }
  }, {
    key: "isUnifiedStatisticsEnabled",
    get: function get() {
      return store.getters.isUnifiedStatisticsEnabled;
    }
  }, {
    key: "mustChangeMenuVisibility",
    value: function mustChangeMenuVisibility(route) {
      if (window.innerWidth < 720 && store.getters.isMenuVisible) {
        store.dispatch(MENU_VISIBLE, false);
      }
    }
  }]);
}(Vue);
export { Menu as default };
__decorate([Watch('$route', {
  immediate: false,
  deep: true
})], Menu.prototype, "mustChangeMenuVisibility", null);